
export enum AppDatatableColumnMode {
    FORCE = "force",
    FLEX = "flex",
    STANDARD = "standard"
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/enums/column-mode.enum.ts